import { render, staticRenderFns } from "./threeDetail.vue?vue&type=template&id=2749edb0&"
import script from "./threeDetail.vue?vue&type=script&lang=js&"
export * from "./threeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports